import styled, { keyframes } from 'styled-components'

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  transition: background 0.2s;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  animation: ${showModal} 200ms;
`

export const ModalWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;
  text-align: left;
  z-index: 10;
  border-radius: 10px;

  @media (max-width: 560px) {
    max-width: 90%;
    margin: auto;
  }

  @media (max-height: 550px) {
    max-height: 95%;
    overflow-y: scroll;
    padding: 0;
  }
`

export const HeaderModalClose = styled.button`
  background: none;
  border: 0;
  position: absolute;
  top: 32px;
  right: 32px;
  transition: all 400ms;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }

  &:hover {
    opacity: 0.6;
  }
`
